import produtos from '../data/produtos.json';
import pecas from '../data/pecas.json';

/**
 * Cor da pintura pela descrição (quando ela diz) ou pelo cliente da peça.
 * As montadoras têm cor de casa: verde John Deere, amarelo CAT/DAF, vermelho AGCO.
 */
const COR_DO_CLIENTE = {
  'John Deere': '#2f7d32',
  'Caterpillar': '#f2b51d',
  'DAF Caminhoes': '#f4c531',
  'AGCO': '#c4262e',
};
const COR_NA_DESCRICAO = [
  [/VERMELH/, '#c4262e'],
  [/AMAREL/, '#f4c531'],
  [/AZUL/, '#1f4f95'],
  [/VERDE/, '#2f7d32'],
  [/PRAT|CINZ/, '#b9bec6'],
  [/BRANC/, '#f3f4f2'],
];
const COR_PADRAO = '#f3f4f2';

const FAMILIA_NA_DESCRICAO = [
  [/GRADE/, 'grade'],
  [/TETO/, 'teto'],
  [/PARA-LAMA|PARALAMA/, 'para-lama'],
  [/MOLDURA/, 'para-lama'],
  [/TERMINAL/, 'terminal'],
  [/DEFLETOR|SUNVISOR/, 'defletor'],
  [/PAINEL|TAMPA|PROTECAO/, 'painel'],
];

export function produtoGeometria(codigo, descricao) {
  const descricaoReal = descricao
    || produtos.find((p) => p.B1_COD === codigo)?.B1_DESC
    || '';
  const up = String(descricaoReal).toUpperCase();
  const peca = pecas[codigo];

  const tipo = FAMILIA_NA_DESCRICAO.find(([re]) => re.test(up))?.[1] || 'para-choque';
  const cor = COR_NA_DESCRICAO.find(([re]) => re.test(up))?.[1]
    || COR_DO_CLIENTE[peca?.cliente]
    || COR_PADRAO;

  const medidas = String(descricaoReal).match(/(\d{2,4})\s*[xX×]\s*(\d{2,4})(?:\s*[xX×]\s*(\d{2,4}))?/);
  const largura = medidas ? Number(medidas[1]) : peca?.largura || 1800;
  const profundidade = medidas ? Number(medidas[2]) : peca?.profundidade || 300;
  const altura = medidas?.[3] ? Number(medidas[3]) : peca?.altura || 400;

  return {
    codigo,
    descricao: descricaoReal,
    tipo,
    cor,
    processo: peca?.processo || 'SMC',
    cliente: peca?.cliente || '',
    largura,
    profundidade,
    altura,
  };
}
